import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCaseDocuments,
  createCaseDoc,
  updateCaseDoc,
  deleteCaseDoc,
  createBulkCaseDocument,
  deleteBulkCaseDocs,
} from "../../../api/cd_caseDocs_api";

export const fetchCaseDocuments = createAsyncThunk(
  "caseDocuments/fetchCaseDocuments",
  async (caseID, { rejectWithValue }) => {
    try {
      const response = await getCaseDocuments(caseID);
      if (!response.success) {
        return rejectWithValue(response.message || "Failed to fetch documents");
      }
      return response.documents || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  },
);

export const createCaseDocument = createAsyncThunk(
  "caseDocuments/createCaseDocument",
  async ({ caseID, formData }, { rejectWithValue }) => {
    try {
      const response = await createCaseDoc(caseID, formData);
      return response.data; // should include the created document
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create document",
      );
    }
  },
);

export const updateCaseDocument = createAsyncThunk(
  "caseDocuments/updateCaseDocument",
  async ({ caseDocId, formData }, { rejectWithValue }) => {
    try {
      const response = await updateCaseDoc(caseDocId, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update document",
      );
    }
  },
);

export const deleteCaseDocument = createAsyncThunk(
  "caseDocuments/deleteCaseDocument",
  async (caseDocId, { rejectWithValue }) => {
    try {
      await deleteCaseDoc(caseDocId);
      return caseDocId;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete document",
      );
    }
  },
);

export const createBulkCaseDocumentAction = createAsyncThunk(
  "caseDocuments/createBulkCaseDocumentAction",
  async (payload, { rejectWithValue }) => {
    try {
      const formData = payload instanceof FormData ? payload : payload.formData;
      const onUploadProgress = payload instanceof FormData ? undefined : payload.onUploadProgress;

      if (!formData || formData.entries().next().done) {
        throw new Error("No files or data to upload");
      }

      const response = await createBulkCaseDocument(formData, onUploadProgress);

      if (!response?.data?.success) {
        throw new Error(response?.data?.message || "Upload failed");
      }

      return response.data;
    } catch (error) {
      console.error("Bulk upload error:", error);
      let errorMessage = "Upload failed";
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      return rejectWithValue(errorMessage);
    }
  },
);

export const deleteBulkCaseDocumentsAction = createAsyncThunk(
  "caseDocuments/deleteBulkCaseDocumentsAction",

  async (caseDocIds, { rejectWithValue }) => {
    try {
      const response = await deleteBulkCaseDocs(caseDocIds);

      return {
        deletedCaseDocIds: caseDocIds,
        response: response.data,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to bulk delete documents",
      );
    }
  },
);
